import { Box, Header, Pressable, Text, VStack } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { getDesignToken, primitive } from 'styles/constants';
export const UpsellItemButton = Pressable.withConfig({
  width: '$72',
  minHeight: '$24',
  backgroundColor: getDesignToken('background-card'),
  borderWidth: 0.5,
  borderColor: primitive.$blackOpacity30,
  borderRadius: primitive.$borderRadius,
  marginRight: 4,
  alignItems: 'center',
  justifyContent: 'space-around',
  flexDirection: 'row',
  paddingX: 2,
});

export const UpsellItemName = Header.withConfig({
  variant: 'headerFour',
  margin: 0,
  fontSize: '14px',
  numberOfLines: 2,
});

export const UpsellItemPrice = Text.withConfig({
  fontSize: 'sm',
});

export const UpsellItemCalories = Text.withConfig({
  fontSize: 'sm',
  flexShrink: 1,
});

export const UpsellSectionContainer = Box.withConfig({
  marginBottom: {
    base: '$2',
    md: '$4',
  },
});

export const UpsellTitle = Header.withConfig({
  accessible: true,
  focusable: true,
  variant: 'headerThree',
  marginBottom: '$5',
});

export const UpsellItemPicture = Picture.withConfig({
  width: '$16',
  height: '$16',
  marginRight: '$2',
});

export const UpsellItemDetails = VStack.withConfig({
  flex: 3,
  marginX: 1,
});
